import { render, staticRenderFns } from "./SafeBottom.vue?vue&type=template&id=07e7db96"
import script from "./SafeBottom.vue?vue&type=script&lang=js"
export * from "./SafeBottom.vue?vue&type=script&lang=js"
import style0 from "./SafeBottom.vue?vue&type=style&index=0&id=07e7db96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports